export const getTraceIdFromResponse = (response: Response | undefined) =>
	response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;
